import type { HeadlineXsmallOneLineProps } from './types';
import { Flex } from '@banhala/ui-kit';
import { HTMLText } from '../../../HTMLText';

/**
 * - TODO
 *   - Tooltip 구현해야합니다.
 *       - header.item.icon이 있는경우,
 *      - header.item.icon.action_type 있는 경우
 */
export const HeadlineXsmallOneLine = ({
  header,
}: HeadlineXsmallOneLineProps) => {
  if (!header) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      testID={header.item.title}
    >
      <HTMLText type="subtitle1" color="content_primary">
        {header.item.title}
      </HTMLText>
    </Flex.Row>
  );
};
